import Swal from 'sweetalert2'

document.querySelectorAll('.add-to-cart')?.forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();

        const url = button.getAttribute('href') ? button.getAttribute('href') : button.dataset.uri;

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                Swal.fire({
                    title: 'Fehler!',
                    text: 'Beim Hinzufügen des Abos ist ein Fehler aufgetreten. Bitte versuche es erneut.',
                    icon: 'error',
                    confirmButtonText: 'Okay',
                })

                throw new Error('Network response was not ok.');
            })
            .then((data) => {
                Swal.fire({
                    title: 'Hinzugefügt!',
                    text: 'Das Abo wurde deinem Warenkorb hinzugefügt. Führe nun mit dem Checkout fort.',
                    icon: 'success',
                    confirmButtonText: 'Zum Checkout',
                }).then((swalEvent) => {
                    if (swalEvent.isConfirmed) {
                        window.location.href = '/experts/checkout';
                    }
                })
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error);

                Swal.fire({
                    title: 'Fehler!',
                    text: 'Beim Hinzufügen des Abos ist ein Fehler aufgetreten. Bitte versuche es erneut.',
                    icon: 'error',
                    confirmButtonText: 'Okay',
                })
            });
    });
});
